import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.surveyApipath + '/withdrawalOrder/');

export const withdrawalOrder = {
	sendSms(mobPhone) {
        return http.get('sendMessage', { params: {
            mobPhone: mobPhone
        } })
    }
};
